import styled, { css } from 'styled-components';
import { HiddenInput, StyledLabel } from '../checkbox/styled';
import { getSizeBy, getColorShade, getColor } from '../../../src/styled/utils';
const StyledDot = css `
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${getSizeBy(1.5)};
  height: ${getSizeBy(1.5)};
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition-duration: 200ms;
  transition-property: background-color;
  content: '';
`;
export const StyledRadio = styled.span `
  position: relative;
  width: ${getSizeBy(4)};
  height: ${getSizeBy(4)};
  padding: ${getSizeBy(1)};
  background-color: transparent;
  border: ${getSizeBy(0.25)} solid ${getColorShade('onSurface', 'outline')};
  border-radius: 50%;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition-duration: 200ms;
  transition-property: border-color, background-color;

  ${HiddenInput}:focus + & {
    border-color: ${getColor('primary')};
  }

  ${HiddenInput}:disabled + & {
    background-color: ${getColorShade('onSurface', 'outline')};
    border-color: ${getColorShade('onSurface', 'outline')};
  }

  ${HiddenInput}:checked:not(:disabled) + & {
    background-color: ${getColor('primary')};
    border: transparent;

    &::before {
      ${StyledDot};
      background-color: ${getColorShade('onPrimary', 'mediumEmphasis')};
    }
  }

  ${HiddenInput}:checked:disabled + & {
    background-color: ${getColorShade('onSurface', 'outline')};

    &::before {
      ${StyledDot};
      background-color: ${getColorShade('onSurface', 'mediumEmphasis')};
    }
  }
`;
export const StyledLabelRadio = styled(StyledLabel) `
  &:hover ${StyledRadio} {
    background-color: ${({ checked, disabled }) => !checked && !disabled && getColorShade('primary', 'hover')};
    border-color: ${({ checked, disabled }) => !checked && !disabled && getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
